import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";
import { CreateNewFollowNotesDialog } from "@/components/dialog/admin/quick-sign-up";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Link } from "react-router-dom";

const data = [
  {
    date: "01.10.25",
    time: "19:00",
    contact: "Call",
    notes: "Some note goes here. Only",
  },
];

function FollowNotes() {
  const [followNotesModal, setFollowNotesModal] = useState(false);


  const closeFollowNotesModal = () => {
    setFollowNotesModal(false);
  };

  return (
    <TabsContent value="followup-notes">
      <div className="mt-5 flex justify-between items-center'">
        <h2 className="text-lg">Follow Up & Nottes</h2>
        <Button onClick={()=>setFollowNotesModal(true)} className="bg-ccyan">
          <Plus size={20} />
          Create New Follow Up & Notes
        </Button>
      </div>

      <Table className="w-full mt-5">
        <TableHeader>
          <TableRow>
            <TableHead className="">Date</TableHead>
            <TableHead className="text-center">Time</TableHead>
            <TableHead className="text-center">Contact Preference</TableHead>
            <TableHead className="text-end">Notes</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array(15)
            .fill(data[0])
            .map((person, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{person.date}</TableCell>
                <TableCell className="text-center">{person.time}</TableCell>
                <TableCell className="text-center">{person.contact}</TableCell>
                <TableCell className="text-end">{person.notes}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {/* dialog */}
      <CreateNewFollowNotesDialog
        isOpen={followNotesModal}
        onClose={closeFollowNotesModal}
        />
    </TabsContent>
  );
}

export default FollowNotes;
